import { ContentTabs } from 'modules/product-details/components/content';
import React, { useRef } from 'react';
import useVisibilityTracking from './use-visibility-tracking';

interface ProductInformationTabProps {
  tabs: ContentTabs;
  activeTab: number | null;
}

/**
 * Product Information Tab component that renders the first tab content for desktop.
 * Since this tab is always visible on desktop, we render the content directly here.
 */
const ProductInformationTab: React.FC<ProductInformationTabProps> = ({
  tabs,
  activeTab,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const trackingRef = useRef<boolean>(false);

  useVisibilityTracking({
    activeTab: activeTab ?? 0,
    contentRef,
    index: 0,
    tabTitle: tabs[0].title,
    trackingRef,
  });

  return (
    <div className="hidden lg:block" ref={contentRef}>
      <div className="border-grey-100 h-2 border-t bg-other-white" />
      {tabs[0].content}
    </div>
  );
};

export default ProductInformationTab;
